import { memo, useState, useContext } from 'react';
import classnames from 'classnames';
import { useMemoizedFn } from 'ahooks';
import { context as Context } from '@gp/components/Context';
// import Loading from '@gp/components/Loading';
// import PlaceholderCard from '@gp/components/PlaceholderCard';
import Filter from './components/Filter';
import RevenueCompletion from './components/RevenueCompletion';
import ProfitCompletion from './components/ProfitCompletion';
import Financials from './components/Financials';
import usePageLog from '@gp/hooks/usePageLog';
import useInitPage from './hooks/useInitPage';
import './index.scss';

interface IFinanceDetailsProps extends IBaseProps {}

const FinanceDetails: React.FC<IFinanceDetailsProps> = (props) => {
  const { style, className, locale = 'en', ...remains } = props;

  const { studioId, studioName } =
    useContext<StudioOverallDetailContextTypes>(Context) || {};

  const [filter, setFilter] = useState<IStudioOverallDetailsFilter>({
    date: '',
    projects: [],
  });

  const handleFilterConfirm = useMemoizedFn((payload) => {
    setFilter({
      ...filter,
      ...payload,
    });
  });

  const { isLoading, dateRange, /* projects, updateProjects */ } = useInitPage({
    studioId,
    filter,
    setFilter,
  });

  usePageLog({
    pageId: 'STUDIO_OVERALL_DETAILS_FINANCE',
    uidType: 'studio_id',
    uid: studioId,
    extInfo: studioName,
  });

  return (
    <>
      <section
        {...remains}
        style={style}
        className={classnames('dbg-studio-overall-details-finance', className)}
      >
        {/* {isLoading && (
          <Loading style={{ position: 'unset' }} loading loadingBg="#f2f3f5" />
        )} */}
        {/* isLoading */false || (
          <>
            <Filter
              studioId={studioId}
              dateRange={dateRange}
              // projects={projects}
              // updateProjects={updateProjects}
              value={filter}
              onConfirm={handleFilterConfirm}
            />
            <h2 className="dbg-studio-overall-details-finance-title">
              Budget Completion
            </h2>
            <RevenueCompletion filter={filter} />
            <ProfitCompletion filter={filter} />
            <Financials />
            {/* <PlaceholderCard title="Middle - Long Time Financials" /> */}
          </>
        )}
      </section>
    </>
  );
};

export default memo(FinanceDetails);
